import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/_reset.css'
import '@/assets/scss/common.scss'
import '@/assets/scss/style.css'
import { Message, Icon, Dialog, Loading, Select, Option, Form, FormItem, Input, Button } from 'element-ui'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Select);
Vue.use(Option);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.config.productionTip = false
Vue.prototype.$message = Message
Vue.prototype.api = ''
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
